import { Link, useLocation } from 'react-router-dom';
import MenuMobile from './MenuMobile';
import { useWaitlistModal } from '../waitlist/WaitlistModal';

const policyLinks = [
  { label: 'Terms of use', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Safety Overview', to: '/safety-overview' },
  { label: 'Data Removal Policy', to: '/data-removal-policy' },
];

const sectionLinks = [
  { label: 'Features', hash: '#features' },
  { label: 'AI Coach', hash: '#coach' },
  { label: 'How it works', hash: '#howitworks' },
];

const BrandMark = () => <img src="/assets/img/logo.svg" alt="" aria-hidden="true" />;

const getSectionHref = (pathname, hash) => (pathname === '/' ? hash : `/${hash}`);

const PricingSoonLink = ({ onClick }) => (
  <Link className="bl-header-pricing-link" to="/pricing" onClick={onClick}>
    <span>Pricing</span>
    <span className="bl-header-pricing-link__badge">Soon</span>
  </Link>
);

const Header1 = ({ scroll, handleMobileMenu }) => {
  const { pathname } = useLocation();
  const { openWaitlistModal } = useWaitlistModal();
  const isPolicyActive = policyLinks.some((link) => link.to === pathname);

  const handleWaitlistClick = () => {
    if (document.body.classList.contains('mobile-menu-visible')) {
      handleMobileMenu();
    }

    openWaitlistModal();
  };

  return (
    <header className={`bl-header ${scroll ? 'bl-header--scrolled' : ''}`}>
      <nav className="bl-header__nav" aria-label="Primary navigation">
        <Link to="/" className="bl-header-logo">
          <BrandMark />
          <span>
            <span className="bl-header-logo__name">BodyLytiX</span>
            <span className="bl-header-logo__sub">Personalized AI Insights</span>
          </span>
        </Link>

        <ul className="bl-header-links">
          {sectionLinks.map((link) => (
            <li key={link.hash}>
              <a href={getSectionHref(pathname, link.hash)}>{link.label}</a>
            </li>
          ))}
          <li>
            <PricingSoonLink />
          </li>
          <li className={`bl-header-policies ${isPolicyActive ? 'active' : ''}`}>
            <Link to="#">
              Terms & Policies <i className="fas fa-angle-down" aria-hidden="true" />
            </Link>
            <ul className="bl-header-policies__menu">
              {policyLinks.map((link) => (
                <li className={pathname === link.to ? 'active' : ''} key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </li>
        </ul>

        <div className="bl-header-actions">
          <button className="bl-header-btn bl-header-btn--primary" type="button" onClick={openWaitlistModal}>
            Apply to Wish List <i className="fas fa-arrow-right" aria-hidden="true" />
          </button>
        </div>

        <button className="bl-header__toggler" type="button" onClick={handleMobileMenu} aria-label="Open mobile menu">
          <i className="fas fa-bars" />
        </button>
      </nav>

      <div className="mobile-menu bl-header-mobile-menu">
        <nav className="menu-box">
          <div className="close-btn" onClick={handleMobileMenu}>
            <i className="fas fa-times" />
          </div>
          <div className="nav-logo" onClick={handleMobileMenu}>
            <Link to="/" className="bl-header-logo bl-header-logo--mobile">
              <BrandMark />
              <span>
                <span className="bl-header-logo__name">BodyLytiX</span>
                <span className="bl-header-logo__sub">Personalized AI Insights</span>
              </span>
            </Link>
          </div>
          <div className="menu-outer">
            <MenuMobile handleCloseMenu={handleMobileMenu} />
          </div>

          <ul className="list-wrap bl-header-mobile-actions">
            <li className="header-btn">
              <button className="bl-header-btn bl-header-btn--primary" type="button" onClick={handleWaitlistClick}>
                Apply to Wish List <i className="fas fa-arrow-right" aria-hidden="true" />
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <div className="menu-backdrop" onClick={handleMobileMenu} />
    </header>
  );
};

export default Header1;
